export const FETCH_HOW_TO_DETAILS_BEGIN = 'FETCH_HOW_TO_DETAILS_BEGIN';
export const FETCH_HOW_TO_DETAILS_SUCCESS = 'FETCH_HOW_TO_DETAILS_SUCCESS';
export const FETCH_HOW_TO_DETAILS_FAILURE = 'FETCH_HOW_TO_DETAILS_FAILURE';
export const SET_SELECTED_BRAND = 'SET_SELECTED_BRAND';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const SET_SELECTED_ARTICLE = 'SET_SELECTED_ARTICLE';
export const VIEW_ENLARGED_IMAGE = 'VIEW_ENLARGED_IMAGE';
export const CLOSE_ENLARGED_IMAGE = 'CLOSE_ENLARGED_IMAGE';
export const VIEW_HOWTOS_DETAIL = 'VIEW_HOWTOS_DETAIL';
export const CLOSE_HOWTOS_DETAIL = 'CLOSE_HOWTOS_DETAIL';
